module.exports = __webpack_public_path__ + "media/whats_your_status_series/step-04-180f1fee.jpg";